var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBronzeMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50085 3.77815L5.19496 0H0L6.61177 8.02858L12.0528 5.7853L8.50085 3.77815Z",
    fill: "#55ACEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8069 0L8.50098 3.77815L11.0465 7.23139L11.626 6.52818L17.0018 0H11.8069Z",
    fill: "#3B88C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9593 7.56479C10.9971 7.46231 11.0212 7.35321 11.0212 7.23751C11.0212 6.71612 10.598 6.29297 10.0766 6.29297H6.92799C6.40614 6.29297 5.98346 6.71612 5.98346 7.23751C5.98346 7.35321 6.00707 7.46231 6.04532 7.56479C4.50667 8.42715 3.46484 10.0711 3.46484 11.9602C3.46437 14.7423 5.71993 16.9979 8.50207 16.9979C11.2842 16.9979 13.5398 14.7423 13.5398 11.9602C13.5398 10.0711 12.4979 8.42715 10.9593 7.56479Z",
    fill: "#FF8A3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66866 13.8573L7.22499 13.301C7.28638 13.2386 7.37517 13.2301 7.44554 13.283C7.44554 13.283 7.9929 13.6896 8.41652 13.6896C8.7967 13.6896 9.18538 13.3718 9.18538 12.9831C9.18538 12.5945 8.78773 12.2681 8.13458 12.2681H7.8328C7.74496 12.2681 7.66562 12.1888 7.66562 12.1005V11.3675C7.66562 11.2702 7.74496 11.1998 7.8328 11.1998H8.13458C8.75278 11.1998 9.07912 10.9 9.07912 10.5202C9.07912 10.1401 8.75278 9.85813 8.3726 9.85813C7.98393 9.85813 7.73693 10.0612 7.60469 10.2109C7.54235 10.2818 7.43704 10.2818 7.36667 10.2204L6.82781 9.69047C6.7565 9.62813 6.76547 9.52282 6.82781 9.46095C6.82781 9.46095 7.5518 8.68359 8.51381 8.68359C9.53816 8.68359 10.4213 9.31077 10.4213 10.2997C10.4213 10.9793 9.9089 11.4827 9.51172 11.6679V11.6948C9.92684 11.8714 10.58 12.4188 10.58 13.1782C10.58 14.1407 9.74124 14.8651 8.52231 14.8651C7.41059 14.8651 6.84481 14.3173 6.65968 14.0793C6.60632 14.016 6.61576 13.9187 6.66866 13.8573Z",
    fill: "#7C4119"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeMedal);
export default __webpack_public_path__ + "static/media/bronze-medal.ff67e55afa941c09055b97a2e4eff9f4.svg";
export { ForwardRef as ReactComponent };